var _circle, _line, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _circle2, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 25,
    r: 25,
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37.5,
    y1: 22.5,
    x2: 40.5,
    y2: 22.5,
    stroke: "white",
    strokeLinecap: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4535 16.0002C10.1776 16.0002 9.95412 16.2309 9.95412 16.5157C9.95412 16.8006 10.1773 17.0312 10.4535 17.0312H18.355C18.6309 17.0312 18.8544 16.8006 18.8544 16.5157C18.8544 16.2309 18.6309 16.0002 18.355 16.0002H10.4535Z",
    fill: "#BFDFBA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49941 19.4525C7.22345 19.4525 7 19.6831 7 19.968C7 20.2528 7.22372 20.4832 7.49941 20.4835H8.97194C9.24791 20.4835 9.47135 20.2528 9.47135 19.968C9.47135 19.6831 9.24791 19.4525 8.97194 19.4525H7.49941Z",
    fill: "#BFDFBA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.17719 23.8185H14.7259C15.0018 23.8185 15.2253 23.5879 15.225 23.303C15.225 23.0182 15.0015 22.7875 14.7256 22.7875H8.17719C7.90123 22.7875 7.67778 23.0182 7.67778 23.303C7.67778 23.5879 7.90123 23.8185 8.17719 23.8185Z",
    fill: "#BFDFBA"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8728 27.2125H14.9048C15.1808 27.2125 15.4042 26.9818 15.4042 26.6972C15.4042 26.4124 15.1808 26.1817 14.9048 26.1817L10.8728 26.1815C10.5969 26.1815 10.3734 26.4121 10.3734 26.697C10.3734 26.9818 10.5969 27.2125 10.8728 27.2125Z",
    fill: "#BFDFBA"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3566 30.0911C12.3566 29.8063 12.1331 29.5756 11.8572 29.5756H9.01956C8.7436 29.5756 8.52015 29.8063 8.52015 30.0911C8.52015 30.376 8.7436 30.6066 9.01956 30.6066H11.8572C12.1331 30.6066 12.3566 30.376 12.3566 30.0911Z",
    fill: "#BFDFBA"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5006 34C18.7766 34 19 33.7694 19 33.4845C19 33.1999 18.7763 32.969 18.5006 32.969H10.5422C10.2663 32.969 10.0428 33.1997 10.0428 33.4845C10.0428 33.7694 10.2663 34 10.5422 34H18.5006Z",
    fill: "#BFDFBA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44768 16C8.17172 16 7.94827 16.2306 7.94827 16.5155C7.94827 16.8004 8.17199 17.031 8.44768 17.031H9.10329C9.37925 17.031 9.6027 16.8004 9.6027 16.5155C9.6027 16.2306 9.37925 16 9.10329 16H8.44768Z",
    fill: "#BFDFBA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.4996 20.483H16.2702C16.5459 20.483 16.7693 20.2526 16.7696 19.9675C16.7696 19.6826 16.5461 19.452 16.2702 19.452H10.4996C10.2236 19.452 10.0002 19.6826 10.0002 19.9675C10.0002 20.2523 10.2236 20.483 10.4996 20.483Z",
    fill: "#BFDFBA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1297 29.5751C13.8537 29.5751 13.6302 29.8057 13.6302 30.0906C13.6302 30.3751 13.8537 30.6061 14.1297 30.6061H15.992C16.2679 30.6061 16.4914 30.3754 16.4914 30.0906C16.4914 29.8057 16.2679 29.5751 15.992 29.5751H14.1297Z",
    fill: "#BFDFBA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25693 33.9997C9.53289 33.9997 9.75634 33.7691 9.75634 33.4842C9.75634 33.1996 9.53289 32.9687 9.25693 32.9687H8.5161C8.24014 32.9687 8.01669 33.1994 8.01669 33.4842C8.01669 33.7691 8.24014 33.9997 8.5161 33.9997H9.25693Z",
    fill: "#BFDFBA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 30.5,
    cy: 25.5,
    r: 12.5,
    fill: "#BFDFBA"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5003 16C25.2621 16 21 20.2615 21 25.5C21 30.7381 25.2616 35 30.5003 35C35.739 35 40 30.7383 40 25.5C40 20.2617 35.7384 16 30.5003 16ZM30.5003 34.0554C25.7821 34.0554 21.944 30.2173 21.944 25.5C21.944 20.7827 25.7822 16.9446 30.4997 16.9446C35.2175 16.9446 39.056 20.7827 39.056 25.5C39.056 30.2173 35.2178 34.0554 30.5003 34.0554Z",
    fill: "black"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M33 23.8906L32.7507 24.7969H28L28.2493 23.8906H33ZM30.7713 30L28.088 26.5L28.0733 25.8438H29.4076C29.7546 25.8438 30.0503 25.7917 30.2947 25.6875C30.5391 25.5807 30.7261 25.4219 30.8556 25.2109C30.9851 24.9974 31.0499 24.7292 31.0499 24.4063C31.0499 23.9297 30.9154 23.556 30.6466 23.2852C30.3778 23.0117 29.9648 22.875 29.4076 22.875H28L28.2493 22H29.4076C30.0039 22 30.4927 22.1055 30.8739 22.3164C31.2576 22.5247 31.5411 22.8112 31.7243 23.1758C31.9101 23.5378 32.0029 23.9479 32.0029 24.4063C32.0029 24.8203 31.9174 25.2018 31.7463 25.5508C31.5777 25.8971 31.3065 26.1758 30.9326 26.3867C30.5611 26.5977 30.0699 26.7031 29.4589 26.7031H29.4369L31.915 29.9375V30H30.7713ZM33 22L32.7507 22.9063L29.0117 22.875L29.261 22H33Z",
    fill: "#231F20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCash);
export default __webpack_public_path__ + "static/media/cash.e3d5ad8a6ce25ad56b5194f6c5fbf294.svg";
export { ForwardRef as ReactComponent };